import React from 'react';

export default function UsersTable({ users }) {
  return (
    <div className="bg-tf-surface border border-tf-primary" data-testid="users-table">
      <div className="px-4 sm:px-5 py-3 sm:py-4 border-b border-tf-primary flex items-center justify-between">
        <h2 className="font-heading font-bold text-xs sm:text-sm tracking-[0.15em] sm:tracking-[0.2em] uppercase text-tf-text">Onboarded Users</h2>
        <span className="font-mono text-[8px] sm:text-[9px] tracking-[0.2em] uppercase text-tf-text-2">{users.length} total</span>
      </div>
      {users.length === 0 ? (
        <div className="px-4 sm:px-5 py-8 sm:py-12 text-center">
          <p className="font-body text-sm text-tf-text-2">No users onboarded yet.</p>
          <p className="font-mono text-[10px] text-tf-text-3 mt-1">Users appear after onboarding via @TrustframeBot</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[500px]">
            <thead>
              <tr className="border-b border-tf-border-muted">
                {['Name', 'Role', 'Email', 'Country', 'KYC'].map(h => (
                  <th key={h} className="px-3 sm:px-5 py-2 sm:py-3 text-left font-mono text-[8px] sm:text-[9px] tracking-[0.2em] uppercase text-tf-text-2">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {users.map((user, i) => (
                <tr key={user.trustframe_id || i} className="border-b border-tf-border-muted last:border-b-0 hover:bg-tf-bg transition-colors duration-200" data-testid={`user-row-${i}`}>
                  <td className="px-3 sm:px-5 py-2 sm:py-3 font-body text-xs sm:text-sm font-medium text-tf-text">{user.name}</td>
                  <td className="px-3 sm:px-5 py-2 sm:py-3">
                    <span className={`inline-block px-1.5 sm:px-2 py-0.5 font-mono text-[8px] sm:text-[9px] tracking-[0.1em] sm:tracking-[0.15em] uppercase border ${
                      user.role === 'Gallery' ? 'border-tf-accent text-tf-accent' : user.role === 'Artist' ? 'border-tf-primary text-tf-primary' : 'border-tf-text-2 text-tf-text-2'
                    }`}>{user.role}</span>
                  </td>
                  <td className="px-3 sm:px-5 py-2 sm:py-3 font-mono text-[10px] sm:text-xs text-tf-text-2 truncate max-w-[120px] sm:max-w-none">{user.email}</td>
                  <td className="px-3 sm:px-5 py-2 sm:py-3 font-body text-xs sm:text-sm text-tf-text-2">{user.country}</td>
                  <td className="px-3 sm:px-5 py-2 sm:py-3">
                    <div className="flex items-center gap-1.5">
                      <div className={`w-2 h-2 rounded-full ${user.kyc_status === 'verified' ? 'bg-tf-success' : 'bg-tf-warning'}`} />
                      <span className="font-mono text-[9px] sm:text-[10px] text-tf-text-2 capitalize">{user.kyc_status || 'pending'}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
